import React from "react";
import { Modal, Button } from "react-bootstrap";

import "./DeleteDocumentModal.css";

const DeleteDocumentModal = ({ open, toggleDeleteModal, deleteDocument }) => {
  const handleClose = () => {
    toggleDeleteModal();
  };
  const handleDelete = () => {
    deleteDocument();
  };

  return (
    <>
      <Modal className="exports-modal" show={open} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>DELETE DOCUMENT?</Modal.Title>
        </Modal.Header>
        <Modal.Body className="deleteBody">
          Are you sure you wish to permanently delete this document?
        </Modal.Body>
        <Modal.Footer>
          <Button className="button-later-md" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="button-primary-md" onClick={handleDelete}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default DeleteDocumentModal;
